<template>
    <div class="d-flex flex-row flex-nowrap gap-4">
        <span>{{ stationName }}</span
        ><span class="fw-semibold"
            >{{ $tm(stationTypeName)
            }}<small
                v-if="stationAlias"
                class="ms-2"
                >({{ stationAlias }})</small
            ></span
        >
    </div>
</template>

<script lang="ts" setup>
import { useLoaders, useTaskLoader } from '@/composeables';
import { $tm } from '@/locize';
import type { ShootingResult } from '@/objects/generated';
import { useCommonStoreRef, useEventCommonStoreRef } from '@/stores';
import { ref, watch } from 'vue';

const props = defineProps<{
    /**
     * This is the id of the station the shooting happened at.
     */
    value: number | null;

    /**
     * The shooting result to display
     */
    row?: ShootingResult;
}>();

const { AddLoader } = useTaskLoader();
useLoaders(AddLoader, ['STATIONTYPES']);

const { Stations } = useEventCommonStoreRef();
const { StationTypeAsSelectLine: StationTypesAsSelectLine } = useCommonStoreRef();

const stationName = ref<string>('');

const stationTypeName = ref<string>('');

const stationAlias = ref<string>('');

watch(
    [StationTypesAsSelectLine],
    () => {
        if (props.value == null) {
            return '-';
        }

        const station = Stations.value.find((x) => x.ID == props.value);
        if (station == null) {
            return props.value.toString();
        }

        const stationType = StationTypesAsSelectLine.value.get(station.StationTypeID);

        stationName.value = station.Name ?? '';
        stationTypeName.value = stationType?.text ?? '';
        stationAlias.value = props.row?.Alias ?? '';
    },
    { immediate: true },
);
</script>
